import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE, entrepriseJsonLd } from "../utils/donneesStructurees";

/**
 * Balises SEO d'une page : titre, description, URL canonique, partages sociaux
 * et données structurées. La fiche entreprise est ajoutée sur toutes les pages,
 * les autres blocs (Service, FAQPage, BreadcrumbList) sont passés en prop.
 *
 * - titre       : viser 60 caractères maximum, Google tronque au-delà
 * - description : viser 155 caractères maximum
 * - chemin      : chemin de la page ("/salle-de-bain"), sert d'URL canonique
 * - canonique   : à ne renseigner que si la page duplique une autre URL
 */
const Seo = ({
  titre,
  description,
  chemin = "/",
  canonique,
  image = "/images/logo-tef.jpg",
  donnees = [],
  noindex = false,
}) => {
  const urlCanonique = `${SITE}${canonique || chemin}`;
  const urlImage = image.startsWith("http") ? image : `${SITE}${image}`;
  const blocs = [entrepriseJsonLd(), ...donnees];

  return (
    <Helmet prioritizeSeoTags>
      <title>{titre}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={urlCanonique} />
      {/* toujours émise : elle remplace celle d'index.html (marquée data-rh) */}
      <meta name="robots" content={noindex ? "noindex, follow" : "index, follow"} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Transition Énergie France" />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:title" content={titre} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={urlCanonique} />
      <meta property="og:image" content={urlImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={titre} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={urlImage} />

      {blocs.map((bloc, i) => (
        <script type="application/ld+json" key={i}>
          {JSON.stringify(bloc)}
        </script>
      ))}
    </Helmet>
  );
};

export default Seo;
